/**
 * Categorical palette for the reporting charts.
 *
 * Ordered so that adjacent slices stay distinguishable, and **validated rather
 * than eyeballed**: every adjacent pair clears the colour-vision-deficiency
 * separation floor, the chroma floor, the lightness band and 3:1 contrast
 * against the chart surface.
 *
 * The eighth slot was `#65a30d` and failed: against the red in slot 7 it
 * separates by only ΔE 5.8 under deuteranopia, below the floor of 6 — which
 * means roughly one man in twelve could not tell a revenue channel from an
 * expense category sitting next to it. Darkening the lime to `#4d7c0f` clears
 * every check with a single-hex change, so the rest of the order — and any
 * screenshot taken before today — stays as it was.
 *
 * Colour is assigned in fixed order and never cycled: a channel keeps its hue
 * when a filter removes the series above it, so the eye can follow one entity
 * across two different reports.
 *
 * Colour is never the only encoding. Every breakdown pairs its swatch with a
 * written label, a percentage and a bar length, so the chart still reads in
 * greyscale, in print, and for anyone who cannot separate two of these hues.
 */
export const PALETTE = [
  '#3563f5', // blue
  '#059669', // emerald
  '#d97706', // amber
  '#7c3aed', // violet
  '#0891b2', // cyan
  '#db2777', // pink
  '#4d7c0f', // olive  — re-stepped from #65a30d for CVD separation
  '#dc2626', // red
] as const;

/** Series colours for the money-over-time chart. All one axis, all one currency. */
export const SERIES_COLOURS = {
  revenue: '#059669',
  expenses: '#dc2626',
  profit: '#3563f5',
  collected: '#0891b2',
} as const;

export function paletteAt(index: number): string {
  return PALETTE[index % PALETTE.length]!;
}
